// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C1DK","col":"styles_col__kaR-P"};